export enum EventFilter {
    CONFIDENCE = 'confidence',
    DATE_RANGE = 'dateRange',
    SOURCE = 'source',
    ALERT_RULE = 'alertRule',
    OBJECT_TYPE = 'objectType',
}

export enum EventSort {
    DATE = 'date',
    CONFIDENCE = 'confidence',
}

export interface EventsBrowseBarConfig {
    filters?: EventFilter[];
    sorts?: EventSort[];
    requireSource?: boolean;
}
